import Swiper from 'swiper';
import { init as productAddToCartInit } from "./productAddToCartComponent";
import { init as productControlsInit } from "./productControlsComponent";
import { init as productBackInStockInit } from "./productBackInStockComponent";
import { init as productGiftCardInit } from "./productGiftCardComponent";
import { init as productImageViewerInit } from "./productImageViewerComponent";
import { init as productMessagesInit } from "./productMessagesComponent";
import { init as productListMessagesInit } from "./productListMessagesComponent";
import { init as productMetaInit } from "./productMetaComponent";
import { init as productMetaPriceInit } from "./productMetaPriceComponent";
import { init as productWishListInit } from "./productWishListComponent";
import { init as productWishListMultipleInit } from "./productWishListMultipleComponent";
import { init as productFullDetailsInit } from "./productFullDetailsComponent";
import { init as productFavoritesInit } from "./productFavoritesComponent";
import { attachEvents as rrOriginalAttachEvents } from "../../../core/js/components/richRelevanceComponent";

import { generate, mergeConfigOverrides } from "../../../core/js/utils/componentUtils";
import { setProductTileSwatchImage, setProductTileSwatchUrl } from "../utils/tileUtils";

import productUtils from "../utils/utils";
import imageViewerTemplate from "family/family-product-image-viewer.j2";

import { familyProductComponentConfigOverride } from "./familyProductComponentConfigOverride";

import productControlsFaceoutTemplate from 'controls/product-controls-faceout.j2';

export function showOtherImages(swiper) {
    const swiperLocation = swiper.container[0];

    $(swiperLocation).parent().find('.o-carousel--hidden').each(function() {
        $(this).removeClass('o-carousel--hidden');
    });
}

function familyProductImageSwiperInitialization() {
    const slideCount = $(this.scopedSelector('.js-carousel-zoom__inner')).children().length;

    const pdpCarousel = new Swiper(`${this.templateLocation} .js-carousel-zoom--product-image`, {
        wrapperClass: 'js-carousel-zoom__inner',
        slideClass: 'js-carousel-zoom__slide',
        nextButton: `${this.templateLocation} .js-carousel__button--next`,
        prevButton: `${this.templateLocation} .js-carousel__button--prev`,
        buttonDisabledClass: 'o-carousel__button--disabled',
        noSwiping: true,
        noSwipingClass: 'js-carousel-zoom--no-swiping',
        spaceBetween: 40,
        effect: 'slide',
        autoplay: 0,
        speed: 500,
        loop: false,
        setWrapperSize: true,
        mode: 'horizontal',
        slidesPerView: 1,
        slidesPerGroup: 1,
        breakpoints: {
            567: {
                slidesPerView: 2.2,
                slidesPerGroup: 1,
                spaceBetween: 10
            }
        },
        runCallbacksOnInit: true,
        onInit: showOtherImages
    });
}

function rrAttachEvents(store) {
    rrOriginalAttachEvents.bind(this)(store);

    $(document).on('touchend click', `${this.templateLocation} .js-swatch-link-category`, (e) => {
        e.preventDefault();

        const colorCode = $(e.target).attr('data-color-code');

        setProductTileSwatchImage(store, e);
        setProductTileSwatchUrl(e);
    });
}

export function generateDictionary(state, dictionary, config) {
    const product = { product: state.product.familyProducts[config.multipleIndex] };

    return Object.assign({}, state, product, dictionary);
}

export function beforeAttach(config, components) {
    const watchArr = _.flattenDeep([config.watch]);

    for (let i = 0; i < watchArr.length; i++) {
        watchArr[i] = watchArr[i].replace('product.', `product.familyProducts.${config.multipleIndex}.`);
    }

    config.watch = watchArr;

    return config;
}

export function init(store, overrides = {}) {
    let config = {
        children: [
            [productControlsInit, {
                templateLocation: '.dom-product-controls',
                forFamilyProduct: true,
                template: productControlsFaceoutTemplate
            }],
            [productBackInStockInit, {
                templateLocation: '.dom-product-back-in-stock-notification',
                forFamilyProduct: true
            }],
            [productGiftCardInit, {
                templateLocation: '.dom-product-gift-card',
                forFamilyProduct: true
            }],
            [productImageViewerInit, {
                templateLocation: '.dom-family-product-image-viewer',
                template: imageViewerTemplate,
                disableZoom: true,
                afterRender: familyProductImageSwiperInitialization,
                afterConstruction: familyProductImageSwiperInitialization,
                forFamilyProduct: true
            }],
            [productMessagesInit, {
                templateLocation: '.js-product-message',
                forFamilyProduct: true
            }],
            [productListMessagesInit, {
                templateLocation: '.dom-product-list-messages',
                forFamilyProduct: true
            }],
            [productMetaInit, {
                templateLocation: '.js-product-meta',
                forFamilyProduct: true,
                watch: ['product.productMeta', 'core.deviceCharacteristics']
            }],
            [productMetaPriceInit, {
                templateLocation: '.dom-product-meta-price',
                forFamilyProduct: true,
                watch: ['product.productMeta', 'core.deviceCharacteristics']
            }],
            [productWishListInit, {
                templateLocation: '.dom-wishlist-add',
                forFamilyProduct: true
            }],
            [productWishListMultipleInit, {
                templateLocation: '.dom-wishlist-list',
                forFamilyProduct: true
            }],
            [productAddToCartInit, {
                templateLocation: '.dom-add-to-cart',
                forFamilyProduct: true
            }],
            [productFullDetailsInit, {
                name: 'familyProductFullDetailsComponent',
                templateLocation: '.dom-product-full-details',
                watch: 'product.productMeta.queryParams',
                forFamilyProduct: true
            }],
            [productFavoritesInit, {
                templateLocation: '.dom-favorited',
                watch: 'product.favorited',
                name: 'familyProductFavoritesComponent',
                forFamilyProduct: true
            }]
        ],
        templateLocation: '.dom-pdp .dom-family-product',
        name: 'familyProductComponent',
        generateDictionary: generateDictionary,
        beforeAttach: beforeAttach
    };
    const product = productUtils.getTargetedProduct(store.getState());
    const familyProducts = product.familyProducts || [];
    const overridenConfig = mergeConfigOverrides(config, familyProductComponentConfigOverride);

    config.multiple = (store) => familyProducts.length;

    return generate(overridenConfig, store, overrides);
}
